<template>
	<div>
		<kefuright></kefuright>
		<!--轮播图-->
		<home-swiper> </home-swiper>
		
		<!-- 专家库 -->
		
		<div class="cebox">
			<div class="banxin">
				<Con></Con>
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">专家库</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="cenei">
					<div class="celeft">
						<div class="cetitle">
							专家库
						</div>
						<div class="cetxt">
							诚邀各类学科专家，根据相关政策、数据及资料，独立发表学术见解，提供专业指导意见共同推进科技成果转化。
						</div>
						<div class="cejin" @click="zhuan_jia">
							专家库入驻
						</div>
					</div>
					<div class="ceyou">
						<div class="cytop">
							专家列表
							<div class="cymore" @click="zhuanmore">
								查看更多>
							</div>
						</div>
						<div class="shenbox">
							<div class="shenli" v-for="i in arr" :key="i.id" @click="zhuan_detail(i.id)">
								<div class="shentitle">
									{{ i.name }}
								</div>
								<div class="shenxin">
									<div class="shentxt">
										{{ i.research.name }}
									</div>
								</div>
								<div class="shenxin">
									<div class="shentxt">
										个人简介：
									</div>
									<div class="shentxt">
										{{ i.resume }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 技术经理人 -->
		<div class="peoplebox">
			<div class="banxin">
				<div class="pt60">
					<div class="gongtop">
						<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
						<div class="zhengbai">技术经理人</div>
						<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
					</div>
				</div>
				<div class="peotitle">
					连接科学技术和企业的中间人，助推科技成果转化、帮助企业转型升级的得力助手。
				</div>
			</div>
		</div>

		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<div class="peoul">
						<div class="peoli" v-for="i in jsList" :key="i.id" @click="applyXq(i.id)">
							<div class="zhubox">{{i.job}}</div>
							<!-- <img :src="item.head" class="head" alt="" /> -->
							<img src="../../../assets/img/images/head_15.png" class="head" alt="">
							<div class="zhutitle">
								{{ i.title }}
							</div>
							<div class="zhutxt">
								{{ i.job_level }}
							</div>
						</div>
					</div>
					<div class="zhuce" @click="apply()">注册技术经理人</div>
				</div>
			</div>
		</div>

		<!-- 人才招聘 -->
		<div class="cebox" style="padding-top: 0;">
			<div class="banxin">
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">人才招聘</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="cenei">
					<div class="celeft zpbg">
						<div class="cetitle">
							招聘列表
						</div>
						<div class="cetxt">
							招纳社会各行业领先人才，聚焦行业最新前沿。
						</div>
						<div class="cejin" @click="zhi_fa">
							职位发布
						</div>
					</div>
					<div class="ceyou">
						<div class="cytop">
							招聘列表
							<div class="cymore" @click="zhao_pin">
								查看更多>
							</div>
						</div>
						<div class="zhaobox">
							<div class="zhaoli" @click="zhi_detail(item.id)" v-for="(item, index) in job" :key="index">
								<div class="zhaotop">
									<div class="zhaotitle oneline">
										{{item.job_name }}
									</div>
									<div class="zhaoge">{{ item.salary }}k</div>
								</div>
								<div class="zhaonum">所需人数:{{item.rens.name}}</div>
								<div class="fuzetxt twolines">
									{{ item.job_describe }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 技术需求大厅 -->
		<div class="quanbg">
			<div class="pt60">
				<div class="gongtop">
					<img src="../../../assets/img/images/tbl_08.png" class="zhengpic" alt="" />
					<div class="zhengbai">技术需求大厅</div>
					<img src="../../../assets/img/images/tbr_08.png" class="zhengpic" alt="" />
				</div>
				<div class="peotitle">
					提供专利转让发布、专利技术展示、专利技术转让，专注专利项目转化、企业专利技术创新需求。
				</div>
			</div>
		</div>

		<div class="jingbox">
			<div class="banxin">
				<div class="jingbai">
					<div class="peoul">
						<div class="fufuli" v-for="i in demand" :key="i.id" @click="getse(i)">
							<div class="peotitle oneline">
								{{ i.title }}
							</div>
							<div class="fuul">
								<div class="fuli" v-for="item in i.label" :key="item.id">
									{{ item.name }}
								</div>
							</div>
							<div class="kfbox">
								<div class="kfleft">
									<div class="kfltxt">
										需求预算
									</div>
								</div>
								<div class="flmian">面议</div>
								<img src="../../../assets/img/images/yar_07.png" class="yanyar" alt="" />
							</div>
						</div>
					</div>
					<div class="zhuce" @click="jin_jishu">进入技术需求大厅</div>
				</div>
			</div>
		</div>
		<!-- 最新动态 -->
		<div class="newbox">
			<div class="qiyetop">
				<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
				<div class="zhengtitle">最新动态</div>
				<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
			</div>
			<div class="qifu">
				<div class="qili" :class="{ qiactive: isActive == index }" v-for="(item, index) in yunList" :key="index"
					@mousemove="yuntab(index)">
					{{ item.name }}
				</div>
			</div>
			<div class="banxin">
				<div class="cengbox" >
					<div class="cengli" v-for="(its, im) in fu" :key="im" @click="dong(its.id)">
						<img :src="urlImg+its.img  " class="cengpic" />
						<div class="cengnei">
							<div class="cengtime">
								{{ its.create_time.substring(0, 10) }}
							</div>
							<div class="cengtitle twolines">
								{{ its.title }}
							</div>
							<!-- <div class="liaobox" @click="dong(its.id)">
								<div class="liaotxt">
									了解更多
								</div>
								<img src="../../../assets/img/images/kra_07.png" class="krapic" alt="" />
								<img src="../../../assets/img/images/krb_07.png" class="krapicact" alt="" />
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 合作院校 -->
		<div class="hezuobox">
			<div class="qiyetop">
				<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
				<div class="zhengtitle">合作院校</div>
				<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
			</div>

			<div class="banxin">
				<div class="hezuoul">
					<img :src="item | ImgFilter" v-for="(item, index) in he_photo" :key="index" class="hezuoli"
						alt="" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import kefuright from '../../../components/common/kefu';
	import FromList from "../../../common/input";
	import Technology from "../../../common/technology"; //技术经理人
	import Con from "./kcon";
	import city from "../../qiyeyun/base/city";
	import {
		formatDate
	} from "../../../common/js/times"; //时间
	import {
		Data
	} from "../../../common/js/api";
	import {
		school_news
	} from "../../common/js/api";
	import {
		recruit_lists,
		expert_lists,
		cloud,
		school_photo,
		Dynamics,
	} from "../../common/js/api";
	import {
		kefu
	} from "../../common/js/api";
	import {
		Kefuyun
	} from "../../../common/js/api";
	import HomeSwiper from "../../../components/common/Swiper";
	import {
		urlImg
	} from "@/common/js/url";

	export default {
		name: "KefuyunForm",
		filters: {
			formatDate(time) {
				time = time * 1000;
				let date = new Date(time);
				return formatDate(date, "MM -dd");
			},
		},
		components: {
			HomeSwiper,
			FromList,
			Con,
			city,
			Technology,
			kefuright
		},

		data() {
			return {
				// 专家库
				arr: [],
				// 技术经理人
				jsList: [],
				// 人才招聘
				job: [],
				demand: [],
				// 最新动态
				yunList: [{
						id: 1,
						name: '人才政策'
					}, {
						id: 2,
						name: '人才服务'
					},
					{
						id: 3,
						name: '培训活动'
					},
					{
						id: 4,
						name: '人在职场'
					}
				],
				isActive: 0,
				he_photo: [],
				fu: [],
				category: '',
				itemId: 237,
			};
		},
		filters: {
			ImgFilter(value) {
				return "http://hout.kehui.cloud/" + value;
			},
		},
		created() {
			this.getKefuyun()
			this.geng_duo()
			this.ren_cai()
			this.index()
			this.he_zuo()
			this.category = this.items;
			this.getList();
			this.urlImg = urlImg();
		},
		methods: {
			dong(ids){
			      this.$router.push({
			          path: '/dynamic',
			          query:{
			              id:ids
			          }
			      });
			   },
			// 最新动态
			yuntab(index) {
				this.isActive = index;
				if (index == 0) {
					this.itemId = 237;
				} else if (index == 1) {
					this.itemId = 238;
				} else if (index == 2) {
					this.itemId = 303;
				} else if (index == 3) {
					this.itemId = 304;
				}
				console.log(this.itemId)
				this.getList();
			},
			// 获取列表
			getList() {
				school_news({
						type: this.itemId,
						page: 1,
						limits: 4,
					})
					.then((res) => {
						console.log(res,'=======')
						this.fu = res.data.data;
					})
					.catch((err) => {});
			},
			// 合作
			he_zuo() {
				var arr = [];
				school_photo({})
					.then((res) => {
						for (var i = 0; i < res.data[0].photo.length; i++) {
							for (var j = 0; j < res.data[0].photo[i].photos.length; j++) {
								arr.push(res.data[0].photo[i].photos[j]);
							}
						}
						this.he_photo = arr;
					})
					.catch((err) => {});
			},
			// 技术需求大厅
			index() {
				cloud({})
					.then((res) => {
						this.managers = res.data.manager;
						this.demand = res.data.demand.slice(0, 8);
					})
					.catch((err) => {});
			},
			getse(item) {
				this.$router.push({
					path: "/need_details",
					query: {
						id: item.id,
					},
				});
			},
			// 进入需求大厅
			jin_jishu() {
				this.$router.push({
					path: "/hall",
				});
			},
			// 技术经理人
			getKefuyun() {
				this.urlImg = urlImg();
				Kefuyun({})
					.then((res) => {

						this.jsList = res.data.manager.slice(0, 8); //技术经理人
					})
					.catch(() => {});
			},
			// 技术经理人  --  进入专题页面
			apply() {
				this.$router.push({
					path: "/apply",
				});
			},
			// 技术经理人详情
			applyXq(id) {
				this.$router.push({
					path: "/manager",
					query: {
						id: id,
					},
				});
			},
			// 职位列表
			ren_cai() {
				recruit_lists({
						nature: "",
						education: "",
						degree: "",
						page: 1,
						limits: 6,
						keywords: "",
					})
					.then((res) => {
						this.job = res.data.data.slice(0, 6);
					})
					.catch((err) => {});
			},
			// 职位详情
			zhi_detail(ids) {
				this.$router.push({
					path: "/positiondetail",
					query: {
						id: ids,
					},
				});
			},
			// 职位发布
			zhi_fa() {
				this.$router.push({
					path: "/position",
				});
			},
			// 职位更多
			zhao_pin() {
				this.$router.push({
					path: "/Recruit",
				});
			},
			// 专家库入驻
			zhuan_jia() {
				this.$router.push({
					path: "/scientistrz",
				});
			},
			// 更多
			zhuanmore() {
				this.$router.push({
					path: "/scientist",
				});
			},
			// 专家列表
			geng_duo() {
				expert_lists({
						default: 1,
						research: "",
						keywords: "",
						views: "",
						time: "",
						page: "",
						limits: 8,
					})
					.then((res) => {
						this.arr = res.data.data;
					})
					.catch((err) => {});
			},
			// 专家详情
			zhuan_detail(id) {
				this.$router.push({
					path: "/expert",
					query: {
						id: id,
					},
				});
			},
			
		},
		mounted() {},
	};
</script>

<style scoped lang="less">
	.banxin {
		width: 1400px;
		margin: 0 auto;
	}

	.pt60 {
		padding-top: 60px;
	}

	.qiyetop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 50px;
		padding-top: 60px;
		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.gongtop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 25px;

		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.jisubox {
		padding-bottom: 60px;
		display: flex;
		background-color: #f6f6f6;
	}



	.peoplebox {
		width: 100%;
		height: 380px;
		background: url('../../../assets/img/images/shubg_02.png') no-repeat center;
		background-size: 100% 380px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}
	}

	.jingbox {
		display: flex;
		background-color: #f6f6f6;
		padding-bottom: 60px;

		.jingbai {
			padding: 30px 20px 40px;
			background-color: #ffffff;
			border-radius: 7px;
			margin-top: -210px;

			.peoul {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				padding-bottom: 10px;

				.peoli:nth-child(4n) {
					margin-right: 0;
				}

				.peoli {
					width: 325px;
					height: 280px;
					border-radius: 5px;
					box-shadow: 0 0 6px #dddddd;
					margin: 0 20px 20px 0;
					text-align: center;
					position: relative;
					cursor: pointer;
					transition: all 0.5s;
					.zhubox {
						border-radius: 0 30px 30px 0;
						background-color: #0289f4;
						height: 40px;
						line-height: 40px;
						width: 105px;
						font-size: 18px;
						color: #ffffff;
						position: absolute;
						top: 15px;
						left: 0;
					}

					.head {
						width: 130px;
						height: 130px;
						margin: 40px 0 20px;
						border-radius: 50%;
					}

					.zhutitle {
						font-size: 24px;
						color: #222222;
						font-weight: bold;
						padding-bottom: 18px;
					}

					.zhutxt {
						font-size: 16px;
						color: #888888;
					}
				}
				.peoli:hover{
					background-color: #0289f4;
					transform: translateY(-5%);
					.zhubox{
						background-color: #ffffff;
						color: #0289f4;
					}
					.zhutitle{
						color: #ffffff;
					}
					.zhutxt{
						color: #ffffff;
					}
				}

				.fufuli:nth-child(4n) {
					margin-right: 0;
				}

				.fufuli {
					width: 325px;
					height: 200px;
					border-radius: 5px;
					box-shadow: 0 0 6px #dddddd;
					margin: 0 20px 20px 0;
					position: relative;
					background-image: linear-gradient(#f8fcfd, #ffffff);
					padding: 0 15px 0 20px;
					cursor: pointer;
					transition: all 0.5s;
					.peotitle {
						padding: 23px 0 12px;
						font-size: 20px;
						color: #222222;
						font-weight: bold;
					}

					.fuul {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						padding-bottom: 11px;
						width: 85%;

						.fuli {
							font-size: 15px;
							color: #adb0b9;
							line-height: 25px;
							height: 25px;
							border: 1px solid #adb0b9;
							padding: 0 5px;
							margin: 0 10px 10px 0;
						}
					}

					.kfbox {
						display: flex;
						align-items: center;
						position: absolute;
						bottom: 24px;
						left: 20px;
						width: 300px;

						.kfleft {
							width: 123px;
							height: 37px;
							background-color: #e9f5fd;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;
							margin-right: 10px;

							.kfpic {
								width: 15px;
								height: 15px;
							}

							.kfltxt {
								font-size: 16px;
								color: #0289f4;
							}
						}

						.flmian {
							width: 65px;
							background-color: #fef3eb;
							height: 37px;
							line-height: 37px;
							font-size: 16px;
							text-align: center;
							color: #ff7200;
							margin-right: 70px;
							cursor: pointer;
						}

						.yanyar {
							width: 20px;
							height: 20px;
							cursor: pointer;
						}
					}
				}
				.fufuli:hover{
					background-image: linear-gradient(#0289f4,#0289f4);
					.peotitle{
						color: #ffffff;
					}
					.fuul{
						.fuli{
							color: #ffffff;
							border: 1px solid #ffffff;
						}
					}
				}
			}

			.zhuce {
				width: 205px;
				height: 40px;
				margin: 0 auto;
				cursor: pointer;
				background-color: #ff4200;
				font-size: 18px;
				color: #ffffff;
				text-align: center;
				border-radius: 5px;
				line-height: 40px;
			}
		}
	}

	.cebox {
		background-color: #f6f6f6;
		padding:  0  0 60px 0;
		display: flex;
		.cenei {
			display: flex;
			align-items: revert;
			justify-content: space-between;
			.zpbg {
				background: url('../../../assets/img/images/zpbg_06.png') no-repeat center ;
			}

			.celeft {
				width: 300px;
				height: 450px;
				background: url('../../../assets/img/images/jiabg_03.png') no-repeat center;
				background-size: 300px 500px;
				padding: 0 27px;
				border-radius: 5px;
				.cetitle {
					font-size: 28px;
					color: #ffffff;
					font-weight: bold;
					padding-bottom: 20px;
					padding-top: 36px;
				}

				.cetxt {
					font-size: 18px;
					color: #ffffff;
					line-height: 35px;
					padding-bottom: 26px;
				}

				.cejin {
					width: 138px;
					height: 34px;
					font-size: 16px;
					color: #ffffff;
					text-align: center;
					line-height: 34px;
					border: 1px solid #ffffff;
					cursor: pointer;
					transition: all 0.5s;
				}
				.cejin:hover{
					background-color: #ffffff;
					color: #0289f4;
				}
			}

			.ceyou {
				width: 1080px;
				background-color: #ffffff;

				.cytop {
					height: 54px;
					background-color: #0289f4;
					position: relative;
					text-align: center;
					line-height: 54px;
					font-size: 24px;
					font-weight: bold;
					color: #ffffff;

					.cymore {
						position: absolute;
						top: 0px;
						font-weight: 500;
						right: 20px;
						color: #ffffff;
						font-size: 16px;
						cursor: pointer;
					}
				}

				.shenbox {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					padding: 20px 0 0 20px;

					.shenli {
						margin: 0 20px 20px 0;
						width: 245px;
						height: 170px;
						background-image: linear-gradient(#f0f7ff, #ffffff);
						box-shadow: 0 0 5px #eeeeee;
						cursor: pointer;
						transition: all 0.5s;
						.shentitle {
							color: #191919;
							font-weight: bold;
							font-size: 24px;
							text-align: center;
							padding: 17px 0 15px;
						}

						.shenxin {
							display: flex;
							align-items: flex-start;
							padding: 12px 20px 0;

							.shentxt {
								font-size: 16px;
								color: #888888;
							}
						}
					}
					.shenli:hover{
						transform: translateY(-3%);
						background-image: linear-gradient(#0289f4, #0289f4);
						.shentitle{
							color: #ffffff;
						}
						.shenxin{
							.shentxt {
								color: #ffffff;
							}
						}
					}
				}

				.zhaobox {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					padding: 20px 0 0 20px;

					.zhaoli {
						margin: 0 18px 20px 0;
						width: 335px;
						height: 170px;
						background-image: linear-gradient(#f0f7ff, #ffffff);
						box-shadow: 0 0 5px #eeeeee;
						padding: 0 20px;
						transition: all 0.5s;
						cursor: pointer;
						.zhaotop {
							display: flex;
							align-items: center;
							justify-content: space-between;
							padding: 20px 0 15px;

							.zhaotitle {
								font-size: 24px;
								color: #191919;
								font-weight: bold;
								max-width: 80%;
							}

							.zhaoge {
								font-size: 18px;
								color: #ff0000;
							}
						}

						.zhaonum {
							font-size: 16px;
							color: #888888;
							padding-bottom: 24px;
						}

						.fuzetxt {
							font-size: 16px;
							color: #888888;
							line-height: 26px;
						}
					}
					.zhaoli:hover{
						background-image: linear-gradient(#0289f4,#0289f4);
						.zhaotop{
							.zhaotitle{
								color: #ffffff;
							}
						}
						.zhaonum{
							color: #ffffff;
						}
						.fuzetxt{
							color: #ffffff;
						}
					}
				}
			}
		}
	}

	.quanbg {
		width: 100%;
		height: 380px;
		background: url('../../../assets/img/images/xuxubg_08.png') no-repeat center;
		background-size: 100% 380px;

		.peotitle {
			font-size: 16px;
			color: #ffffff;
			text-align: center;
		}
	}

	.newbox {
		padding-bottom: 60px;
		background-color: #f6f6f6;

		.qifu {
			border-bottom: 1px solid #e5e5e5;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 50px;

			.qili {
				font-size: 24px;
				color: #333333;
				margin: 0 50px;
				border-bottom: 3px solid transparent;
				padding-bottom: 14px;
				cursor: pointer;
			}

			.qiactive {
				border-bottom: 3px solid #0289f4;
				color: #0289f4;
			}
		}

		.cengbox {
			display: flex;
			align-items: flex-start;

			.cengli:nth-child(4n) {
				margin-right: 0;
			}

			.cengli {
				width: 335px;
				height: 320px;
				background-color: #ffffff;
				box-shadow: 0 0 5px #dddddd;
				margin-right: 20px;
				transition: all 0.5s;
				cursor: pointer;
				.cengpic {
					width: 100%;
					height: 180px;
				}

				.cengnei {
					padding: 17px 18px 0;

					.cengtime {
						font-size: 14px;
						color: #555555;
						padding-bottom: 15px;
					}

					.cengtitle {
						font-size: 22px;
						color: #222222;
						font-weight: bold;
						line-height: 30px;
					}

					.liaobox {
						cursor: pointer;
						margin-top: 80px;
						padding: 0 15px;
						height: 55px;
						background-color: #f6f6f6;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.liaotxt {
							font-size: 16px;
							color: #555555;
						}

						.krapic {
							width: 44px;
							height: 32px;
						}

						.krapicact {
							width: 44px;
							height: 32px;
							display: none;
						}
					}

					.liaobox:hover {
						.krapic {
							display: none;
						}

						.krapicact {
							display: block;
						}
					}
				}
			}
			.cengli:hover{
				transform: translateY(-5%);
				background-color: #0289f4;
				.cengtime {
					color: #ffffff;
				}
				
				.cengtitle {
					color: #ffffff;
				}
			}
		}
	}

	.hezuobox {
		padding-bottom: 20px;
		background-color: #f6f6f6;

		.hezuoul {
			display: flex;
			align-items: center;
			flex-wrap: wrap;

			.hezuoli:nth-child(3n) {
				margin-right: 0;
			}

			.hezuoli {
				width: 430px;
				height: 115px;
				margin: 0 55px 40px 0;
				transition: all 0.5s;
			}
			.hezuoli:hover{
				transform: translateY(-10%);
				box-shadow: 0 0 5px #dddddd;
			}
		}
	}
	@media screen and (max-width: 1200px) {
		.banxin{
			width: 98%;
			margin: 0 auto;
			display: block;
		}
		.qiyetop .zhengtitle{
			font-size: 3rem;
		}
		.cebox .cenei{
			flex-wrap: wrap;
		}
		.cebox .cenei .celeft{
			width: 100%;
			background-size: cover;
			margin-bottom: 1.5rem;
		}
		.cebox .cenei .celeft .cetitle{
			font-size: 2rem;
		}
		.cebox .cenei .celeft .cetxt{
			font-size: 1.6rem;
			width: 60%;
			line-height: 2.5rem;
		}
		.cebox .cenei .celeft .cejin{
			width: 16rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.8rem;
		}
		.cebox .cenei .ceyou .cytop{
			font-size: 2rem;
			height: 3.5rem;
			line-height: 3.5rem;
		}
		.cebox .cenei .ceyou .shenbox{
			justify-content: space-between;
		}
		.cebox .cenei .ceyou .cytop .cymore{
			font-size: 1.4rem;
		}
		.cebox .cenei .ceyou .shenbox .shenli{
			margin: 0 0 1rem;
			width: 48%;
			height: 12rem;
		}
		.cebox .cenei .ceyou .shenbox .shenli .shentitle{
			font-size: 1.8rem;
		}
		.cebox .cenei .ceyou .shenbox .shenli .shenxin .shentxt{
			font-size: 1.4rem;
		}
		.peoplebox{
			height: 25rem;
			background-size: cover;
		}
		.gongtop .zhengbai{
			font-size: 3rem;
		}
		.peoplebox .peotitle{
			font-size: 1.6rem;
			padding: 0 3rem;
			line-height: 2.2rem;
		}
		.jingbox .jingbai .peoul{
			justify-content: space-between;
		}
		.jingbox .jingbai .peoul .peoli{
			width: 49%;
			margin: 0 0 1.2rem;
			height: 18rem;
		}
		.jingbox .jingbai .peoul .peoli .zhubox{
			width: 10rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.7rem;
		}
		.jingbox .jingbai .peoul .peoli .head{
			width: 8rem;
			height: 8rem;
			margin: 3rem auto 1rem;
		}
		.jingbox .jingbai .peoul .peoli .zhutitle{
			font-size: 1.8rem;
		}
		.jingbox .jingbai .peoul .peoli .zhutxt{
			font-size: 1.4rem;
		}
		.jingbox .jingbai .zhuce{
			width: 15rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.6rem;
		}
		.cebox .cenei .ceyou .zhaobox{
			padding: 1rem;
			justify-content: space-between;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli{
			width: 49%;
			margin: 0 0 2rem;
			height: 12rem;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli .zhaotop .zhaotitle{
			font-size: 1.7rem;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli .zhaotop .zhaoge{
			font-size: 1.7rem;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli .zhaonum{
			font-size: 1.4rem;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli .fuzetxt{
			font-size: 1.4rem;
			line-height: 2.1rem;
		}
		.cebox .cenei .ceyou .zhaobox .zhaoli .zhaotop{
			padding-top: 1.5rem;
		}
		.quanbg{
			height: 25rem;
			background-size: cover;
		}
		.quanbg .peotitle{
			font-size: 1.8rem;
			line-height: 2.7rem;
			padding: 0 2rem;
		}
		.jingbox .jingbai .peoul .fufuli{
			margin: 0 0 2rem;
			width: 48%;
			height: 14rem;
		}
		.jingbox .jingbai .peoul .fufuli .peotitle{
			font-size: 1.8rem;
		}
		.jingbox .jingbai .peoul .fufuli .fuul .fuli{
			font-size: 1.2rem;
			height: 2.5rem;
			line-height: 2.5rem;
		}
		.jingbox .jingbai .peoul .fufuli .kfbox .kfleft{
			width: 10rem;
			height: 2.8rem;
			line-height: 2.8rem;
		}
		.jingbox .jingbai .peoul .fufuli .kfbox .kfleft .kfltxt{
			font-size: 1.5rem;
		}
		.jingbox .jingbai .peoul .fufuli .kfbox{
			width: 100%;
		}
		.jingbox .jingbai .peoul .fufuli .kfbox .flmian{
			width: 8rem;
			height: 2.8rem;
			line-height: 2.8rem;
			font-size: 1.5rem;
			margin-right: 1rem;
		}
		.jingbox .jingbai .peoul .fufuli .kfbox .yanyar{
			width: 1.6rem;
			height: 1.6rem;
		}
		.newbox .qifu .qili{
			font-size: 1.8rem;
		}
		.newbox .cengbox{
			flex-wrap: wrap;
			justify-content: space-between;
		}
		.newbox .cengbox .cengli{
			margin: 0 0 2rem;
			width: 48%;
			height: 27rem;
		}
		.newbox .cengbox .cengli .cengpic{
			height: 14rem;
		}
		.newbox .cengbox .cengli .cengnei .cengtime{
			font-size: 1.4rem;
		}
		.newbox .cengbox .cengli .cengnei .cengtitle{
			font-size: 1.6rem;
			line-height: 2rem;
		}
		.newbox .cengbox .cengli .cengnei .liaobox{
			margin-top: 1.5rem;
		}
		.newbox .cengbox .cengli .cengnei .liaobox .liaotxt{
			font-size: 1.5rem;
		}
		.hezuobox .hezuoul{
			justify-content: space-between;
		}
		.hezuobox .hezuoul .hezuoli{
			width: 48%;
			height: 8rem;
			margin: 0 0 2rem ;
		}
	}
</style>